import React from 'react'
import PropTypes from 'prop-types'
import { Card, Button } from 'react-bootstrap'
import LoadingSpinner from '../Helper/LoadingSpinner';
import { Access, hasAccess } from '../Helper/Helper';
import useToken from '../App/useToken';
// import useToken from '../App/useToken';
export default function ForestDetailsSummary(props) {

    const { getCustomer } = useToken()
    const customer = getCustomer()
   
    const area = props.avgData && props.avgData.area && props.avgData.area !== 0.000 ? props.avgData.area : '' 
    const areaCovered = props.ctx.showShapeData?.current && props.totStandData?.areaCovered !== 0 ? props.totStandData?.areaCovered : props.totStandData?.area
    const treeDensity = props.forestData && props.avgData && props.avgData.area && props.avgData.area !== 0.000 ? Number(props.forestData.possibleTrees/props.avgData.area).toFixed(3) : '' 
    const basalArea = props.forestData && props.avgData && props.avgData.area && props.avgData.area !== 0.000 ? Number(props.forestData.basalArea/props.avgData.area).toFixed(3) : '' 
    const title = props.name && !props.ctx.showShapeData?.current ? props.name : props.name && props.ctx.showShapeData?.current && props.ctx.selectedTimeFrame && props.ctx.showShapeData?.current ? props.name + " - " + props.ctx.selectedTimeFrame : props.name && props.ctx.showShapeData?.current && !props.ctx.selectedTimeFrame ? props.name + " - Select time frame to show data" :  "No item selected"
    const cardHeader = (
        <Card.Header style={{fontSize: "1em", fontWeight: "bold", display: "flex", lineBreak: "anywhere" }}>
                {title} 
                {!props.ctx.showShapeData?.current && props.name ? 
                    (<Button style={{border: "2px outset #00d098", marginLeft:"1em"}} size='sm' variant="outline-secondary" onClick={() => props.setViewTable()}>
                        Toggle Hist/Table
                    </Button>
                    ) : null
                }
                {hasAccess(customer, Access.STEM_CURVE.number) && !props.ctx.showShapeData?.current && props.name ? 
                    (<Button style={{border: "2px outset #00d098", marginLeft:"1em"}} size='sm' variant="outline-secondary" onClick={() => props.setViewStemCurve()}>
                         {props.viewStemCurve ? "Show hist/table":"Show stem curve plots"}
                    </Button>
                    ) : null
                }
        </Card.Header>
    )
    
    const list = ((props.ctx.showShapeData?.current && props.totStandData && props.totStandData.possibleTrees ) || (!props.ctx.showShapeData?.current && props.forestData && props.avgData && props.forestData.possibleTrees > 0 )) ?
    ( <ul style={{paddingBottom: '10px'}}>
        <Card.Text>
            Total Number of Trees: {props.ctx.showShapeData?.current ? props.totStandData.possibleTrees : props.forestData.possibleTrees > 0 ?  props.forestData.possibleTrees  : "No trees identified"} 
        </Card.Text>
        <Card.Text>
            Area (hectare): {props.ctx.showShapeData?.current ? Number(props.totStandData.area).toFixed(3) : Number(area).toFixed(3)}
        </Card.Text>
       {props.ctx.showShapeData?.current && props.totStandData && props.totStandData.areaCovered !== 0 && <Card.Text>
            Covered area (percent): {props.ctx.showShapeData?.current ? Number(areaCovered/props.totStandData.area).toFixed(3)*100 : "-"}
        </Card.Text>}
        <Card.Text>
            Tree Density (trees per hectare): {props.ctx.showShapeData?.current ? Number(props.totStandData.possibleTrees/areaCovered).toFixed(3) : treeDensity}
        </Card.Text>
        <Card.Text>
            Basal Area Density (m²/ha): {props.ctx.showShapeData?.current ? Number(props.totStandData.basalArea/areaCovered).toFixed(3) : basalArea}
        </Card.Text>
        <Card.Text>
            Avarage Volume: {props.ctx.showShapeData?.current ? Number(props.totStandData.sumVol/props.totStandData.noVol).toFixed(3) : props.avgData.avgVol} 
        </Card.Text>
        <Card.Text>
            Avarage DBH: {props.ctx.showShapeData?.current ? Number(props.totStandData.sumDBH/props.totStandData.noDBH).toFixed(3) : props.avgData.avgDBH} 
        </Card.Text>
        <Card.Text>
            Avarage Height: {props.ctx.showShapeData?.current ? Number(props.totStandData.sumHeight/props.totStandData.noHeight).toFixed(3) : props.avgData.avgHeight} 
        </Card.Text>
        {/* <Card.Text>
            Trees Discarded (DBH cutoff 0.7m): {props.ctx.showShapeData?.current ? props.totStandData.discardedTrees : props.forestData.discardedTrees} 
        </Card.Text> */}
        </ul>
        ) : ((props.ctx.showShapeData?.current && props.totStandData) || (!props.ctx.showShapeData?.current && props.forestData && props.avgData)) ? (
            <ul style={{paddingBottom: '10px'}}>
                <Card.Text>
                Total Number of Trees: {props.ctx.showShapeData?.current ? props.totStandData?.possibleTrees : props.forestData.possibleTrees > 0 ?  props.forestData.possibleTrees  : "No trees identified"} 
                </Card.Text>
                <Card.Text>
                Area (hectare): {props.ctx.showShapeData?.current ? props.totStandData?.area : area}
                </Card.Text>
            </ul>) : null
    const cardBody = props.loading ? <LoadingSpinner/> : ((props.ctx.showShapeData?.current && props.totStandData) || (!props.ctx.showShapeData?.current && props.forestData && props.avgData)) ? 
    (<Card.Body>
        <Card.Title> Summary </Card.Title>
            {/* {props.viewTable && customer.customerId === '101010' ?  */}
            {/* // <Button variant="outline-secondary" onClick={props.toggleEditTable()} disabled={props.chartWrappers === {'DbhHist': null, 'VolumeHist': null, 'HeightHist': null }}>{props.editTable ? 'Stop editing' : 'Edit table'}</Button> : */}
            {/* <Button variant="outline-secondary" onClick={handleDownloadImage} disabled={props.chartWrappers === {'DbhHist': null, 'VolumeHist': null, 'HeightHist': null }}>Download histograms</Button> */}
        
    {list}
   <Button onClick={props.downloadCSV} variant="outline-secondary">
    Export CSV
    </Button>

    <Button onClick={props.downloadGeojson} variant="outline-secondary">
        Export Geojson...
    </Button>
    </Card.Body> ) : 
    (<Card.Body>
        <Card.Title> Summary </Card.Title>
        {props.loading ? <LoadingSpinner /> : props.loadingError ? <p>{props.loadingError}</p> : <p>No data</p>}
    </Card.Body>)
    
    return (
        <Card
            bg={'dark'}
            key={'ForestDetailsSummary'}
            text={'white'}
            style={{ width: props.style, height: 'fit-content', margin: '1em', border: "3px outset #0f5132" }}
        >
            {cardHeader}
            {cardBody}

        </Card>
    )
}


ForestDetailsSummary.propTypes = {
    toggleEditTable: PropTypes.func.isRequired,
    editTable: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    style: PropTypes.number.isRequired,
    viewTable: PropTypes.bool.isRequired,
    viewStemCurve: PropTypes.bool.isRequired,
    setViewTable: PropTypes.func.isRequired,
    setViewStemCurve: PropTypes.func.isRequired,
    chartWrappers: PropTypes.object.isRequired,
    forestData: PropTypes.object.isRequired,
    ctx: PropTypes.object.isRequired,
    totStandData: PropTypes.object.isRequired,
    downloadGeojson: PropTypes.func.isRequired,
    downloadCSV: PropTypes.func.isRequired,
    loading: PropTypes.string.isRequired,
    loadingError: PropTypes.string,
  }